import React, { useContext } from 'react';
import { Row, Col } from "react-bootstrap";
import img from '../../../assets/Img';
import { useTranslation } from 'react-i18next';
 

const translations = {
  en: require('../../../Translate/en.json').ContentMarketing.ServicesSection,
  ar: require('../../../Translate/ar.json').ContentMarketing.ServicesSection,
};

const ServicesSection = () => {
  const { i18n } = useTranslation();
    const isLang = i18n.language;
  const t = translations[isLang || 'en'];

  return (
    <div className="services-section">
      <Row >
        {/* ✅ قسم خدمات كتابة المحتوى */}
        <Col xs={12} md={6}>
          <h2 className="section-title">{t.CopywritingServices.title}</h2>
          <p className="section-subtitle">{t.CopywritingServices.subtitle}</p>
          <ul className="service-list">
            {Object.keys(t.CopywritingServices.items).map((key, index) => (
              <li key={index}>
                <strong>{t.CopywritingServices.items[key].title}:</strong> {t.CopywritingServices.items[key].description}
              </li>
            ))}
          </ul>
        </Col>

        <Col xs={12} md={6} className="d-flex justify-content-center align-items-center ">
          <img
            width={500}
            height={300}
            src={img.ContentMarketing1}
            alt="Copywriting illustration"
            className="service-image"
          />
        </Col>

        {/* ✅ قسم إنشاء محتوى وسائل التواصل الاجتماعي */}
        <Col xs={12} md={6} className="d-flex justify-content-start align-items-start ">
          <img
            width={500}
            height={300}
            src={img.ContentMarketing1}
            alt="Social Media Content Creation"
            className="service-image mt-5"
          />
        </Col>

        <Col xs={12} md={6}>
          <h2 className="section-title mt-5">{t.SocialMediaContent.title}</h2>
          <p className="section-subtitle">{t.SocialMediaContent.subtitle}</p>
          <ul className="service-list">
            {Object.keys(t.SocialMediaContent.items).map((key, index) => (
              <li key={index}>
                <strong>{t.SocialMediaContent.items[key].title}:</strong> {t.SocialMediaContent.items[key].description}
              </li>
            ))}
          </ul>
        </Col>
      </Row>
    </div>
  );
};

export default ServicesSection;
